/* globals window, document */

import Vue from 'vue';
import URLQueryBuilder from 'url-query-builder';

import { RestComponent } from '../../../mixins/rest-component';
import { TranslatedComponent } from '../../../mixins/translated-component';
import QdSkyfish from '../../skyfish/skyfish.js';
import template from './page-content.vhtml';

export const PageContent = Vue.component( 'page-content', {
	mixins: [
		RestComponent,
		TranslatedComponent,
	],
	components: {
		QdSkyfish,
	},
	template: template,
	props: {
		siteData: {
			type: Object,
			default: () => { },
		},
	},
	data: () => ({
		isTextsShown: false,	
		i18nSorted: [],
		isCopied: '',
		isReseting: null,
		popupId: null,
		urlParameters: [],
		paginationTransition: 'opacity-slide',
		navToParent: false,
		hoverState: false,
	}),
	computed: {
		postId() {
			return this.content && this.content.post && this.content.post.ID || null;
		},
	},
	watch: {
		content() {
			this.sortI18n();
			this.updateLangs(Object.keys(this.content.post.i18n).map(key => key) );
		},
		language() {
			this.sortI18n();
			if (this.hasOwnProperty('content')) {
				document.title = this.content.metaTitle[this.language];
			}
		},
		isCopied() {
			this.resetCopy();
		},
	},
	methods: {
		updateLangs( langs ) {
			this.langs = langs;
			this.$emit('updatelangs', langs);
		},
		showTexts() {
			this.$emit('updatetransition', 'fade');
			this.$nextTick( function() {
				this.updateUrl('texts', '1');
				this.isTextsShown = true;
			});
		},
		hideTexts() {
			this.isTextsShown = false;
			this.updateUrl('texts', '' );
		},
		doCopy( lang, text ) {
			const vue = this;
			this.$copyText(text)
			.then(function() {
				vue.isCopied = lang;
			});
		},
		resetCopy() {
			clearTimeout(this.isReseting);
			this.isReseting = setTimeout(() => {
				this.isCopied = '';
			}, 2000);
		},
		sortI18n() {
			let i18n = Object.values(this.content.post.i18n);
			i18n.forEach((item, index) => {
				if (this.language == item.lang) {
					const elm = i18n.splice(index, 1);
					i18n.unshift(elm[0]);
				}
			});
			this.i18nSorted = i18n;
		},
		updateUrl(name, value) {
			const urlParams = {};
			urlParams[name] = value;
			const q = new URLQueryBuilder(document.location.href, urlParams);

			if (value.length === 0 || value === null) {
				q.delete(name);			
			}
			window.history.replaceState(null, null, q.getUrl());
		},
		navigateToParent(to) {
			this.paginationTransition = 'opacity-slide-right';
			this.$nextTick(function() {
				this.navToParent = true;
				this.navigateRight(to);
			});
		},
		updateHoverState(hoverState) {
			this.hoverState = hoverState;
		},
		hoverCondition(websiteColor) {
			if(this.hoverState) {
				return {
					color: websiteColor
				};
			} else {
				return {
					color: '#f2f2f2'
				};
			}
		}
	},
	mounted() {
		this.urlParameters = getAllUrlParams();

		if (this.urlParameters.hasOwnProperty('texts')) {
			this.showTexts();
		}
	},
});

function getAllUrlParams(url) {

	// get query string from url (optional) or window
	var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

	// we'll store the parameters here
	var obj = {};

	// if query string exists
	if (queryString) {

		// stuff after # is not part of query string, so get rid of it
		queryString = queryString.split('#')[0];

		// split our query string into its component parts
		var arr = queryString.split('&');

		for (var i = 0; i < arr.length; i++) {
			// separate the keys and the values
			var a = arr[i].split('=');

			// in case params look like: list[]=thing1&list[]=thing2
			var paramNum = undefined;
			var paramName = a[0].replace(/\[\d*\]/, function (v) {
				paramNum = v.slice(1, -1);
				return '';
			});

			// set parameter value (use 'true' if empty)
			var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

			// (optional) keep case consistent
			paramName = paramName.toLowerCase();
			paramValue = paramValue.toLowerCase();

			// if parameter name already exists
			if (obj[paramName]) {
				// convert value to array (if still string)
				if (typeof obj[paramName] === 'string') {
					obj[paramName] = [obj[paramName]];
				}
				// if no array index number specified...
				if (typeof paramNum === 'undefined') {
					// put the value on the end of the array
					obj[paramName].push(paramValue);
				}
				// if array index number specified...
				else {
					// put the value at that index number
					obj[paramName][paramNum] = paramValue;
				}
			}
			// if param name doesn't exist yet, set it
			else {
				obj[paramName] = paramValue;
			}
		}
	}

	return obj;
}



// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-content/page-content.js